import { faEnvelope, faMobileScreen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LogoAndText from '../components/LogoAndText';
import {toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import CustomToastContainer from '../components/CustomToastContainer.js';
import { forgotPassword } from '../apiServices/apiServices.js';
import { generateOtpMethod } from '../utils/otpUtils.js';

export default function ForgotPasswordForm() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');

    const handleSubmit = async (e) => {
      e.preventDefault();
  
      const data = {
        phone,
        email
      };
  
      try {
        const response = await forgotPassword(data);
        // console.log("Response : ", response);
        if (response && response.success) {
          const generateOtpRequest = { id: response?.data?.passenger?.id, isSignUp: false };
          generateOtpMethod(generateOtpRequest);
          navigate('/verifyotp', { state: { data: response?.data?.passenger, isSignUp: false } });
        } else {
          toast.error(response.message || 'Request failed');
        }
      } catch (error) {
        console.error('Error:', error);
        toast.error('An error occurred. Please try again.');
      }
    };
  return (
    <>
      <div className="bg-gray-100 flex flex-col items-center justify-center h-screen p-4 md:p-10">
        <div className="w-full md:w-1/2 py-10 md:py-20">
          <div className='mb-20'>
            <LogoAndText/>
          </div>

          <h1 className="text-gray-600 font-semibold text-sm md:text-md text-center mb-8 md:mb-8">
            Enter your details to reset your password
          </h1>
          <div className="flex justify-center">
            <form className="w-full sm:w-3/4 md:w-1/2" id="myForm" onSubmit={handleSubmit}>
              <div className="mb-6 md:mb-8">
                <div className="relative z-0 w-full mb-5 group">
                  <FontAwesomeIcon
                    icon={faMobileScreen}
                    className="absolute text-[#BE1F18] left-0 top-3"
                  />
                  <input
                    type="text"
                    name="phone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    id="floating_phone"
                    className="block py-2.5 pl-8 w-full text-sm text-[#BE1F18] bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#BE1F18] peer"
                    placeholder=" "
                    required
                  />
                  <label
                    htmlFor="floating_phone"
                    className="peer-focus:font-medium absolute left-8 text-sm text-[#BE1F18] duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:left-8 peer-focus:text-[#BE1F18] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    Phone Number
                  </label>
                </div>
              </div>
              <div className="mb-6 md:mb-8">
              <div className="relative z-0 w-full mb-5 group">
                <FontAwesomeIcon icon={faEnvelope} className="absolute text-[#BE1F18] left-0 top-3" />
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  id="floating_email"
                  className="block py-2.5 pl-8 w-full text-sm text-[#BE1F18] bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#BE1F18] peer"
                  placeholder=" "
                  required
                />
                <label
                  htmlFor="floating_email"
                  className="peer-focus:font-medium absolute left-8 text-sm text-[#BE1F18] duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:left-8 peer-focus:text-[#BE1F18] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Email
                </label>
              </div>
            </div>

              <button
                type="submit"
                className="bg-[#BE1F18] text-white hover:bg-opacity-90 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center"
              >
                Submit
              </button>

            </form>
          </div>
        </div>
      </div>
      <CustomToastContainer/>
    </>
  );
}
